'use strict'

import React from 'react';

import { AppBar, Toolbar, Button, Typography, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import Link from 'next/link';
import { withRouter } from 'next/router';
import { ScreenSize } from '../../lib/screensize';
// import Auth from '@aws-amplify/auth';

const _Labels = {
  goToGallery: 'Shop',
  goToCommission: 'Create',
  goToOrders: 'Commissions',
  getStarted: `Get Started`
}


/*
 * Initial blue to green
 startColor = #430089
 endColor = #82ffa1

 light blue
 #4ca1af
 #c4e0e5
 */

const startColor = '#4ca1af';
const endColor = '#F8A6CD';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    zIndex: theme.zIndex.drawer + 1,
    background: `linear-gradient(to right bottom, ${startColor}, ${endColor})`
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(9),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
  },
  inputInput: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(10),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  logo: {
    textDecoration: 'none !important',
    color: 'inherit',
  },
  shopButton: {
    textDecoration: 'none !important',
    color: 'inherit',
  },
  noPurpleLink: {
    textDecoration: 'none !important',
    color: 'inherit',
  },
  getStarted: {
    textDecoration: 'none !important',
    color: 'inherit',
    background: `linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)`,
  }
}));

interface IProps {
  isMobile: boolean;
  classes?: any;
  children?: any;
}

interface IHeaderState {
  screenSize: ScreenSize;
}

const HeaderNoUser = (props: any) => {
  const classes = useStyles(props);

  const redirectPath = `https://${window.location.host}/create/`;
  const hostedUiPath = `https://artmix-beta-beta.auth.us-east-1.amazoncognito.com/login?response_type=code&client_id=6l40b9if6t1m4e96tui0tfrco3&redirect_uri=${redirectPath}`;

  return (
    <AppBar className={classes.root} position="fixed">
      <Toolbar>
        <Button className={classes.logo} variant={'text'} color="inherit" href="/">
          <Link href={'/'}>
            <Typography variant="h5" color="inherit" noWrap={true}>Artmix</Typography>
          </Link>
        </Button>
        <div className={classes.grow} />
        <Button className={classes.shopButton} variant={'text'} color="inherit" href="/">
          <Link href={'/'}>
            <Typography variant="h5" color="inherit" noWrap={true}>Shop</Typography>
          </Link>
        </Button>
        <Button variant="outlined" className={classes.getStarted} color="inherit">
          <a className={classes.logo} href={hostedUiPath}>
            <Typography variant="h6" color="inherit" noWrap={true}>{_Labels.getStarted}</Typography>
          </a>
        </Button>
        <Button color="inherit">
          <a className={classes.logo} href={hostedUiPath}>
            <Typography variant="body1" color="inherit" noWrap={true}>{`Sign In`}</Typography>
          </a>
        </Button>
      </Toolbar>
    </AppBar>
  )
};

export default withRouter(HeaderNoUser);